import {AbstractControl, ValidationErrors, ValidatorFn} from '@angular/forms';

export function passwordStrengthValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value: string = control.value ?? '';
    const errors: ValidationErrors = {};
    if (value.length < 8) errors['minLength8'] = true;
    if (!/[0-9]/.test(value)) errors['requireDigit'] = true;
    if (!/[a-z]/.test(value)) errors['requireLowercase'] = true;
    if (!/[A-Z]/.test(value)) errors['requireUppercase'] = true;
    return Object.keys(errors).length ? errors : null;
  };
}

export function emailArrayValidator(): ValidatorFn {
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return (control: AbstractControl): ValidationErrors | null => {
    const emails: string[] = control.value ?? [];
    if (emails.length === 0) return null;
    return emails.every(email => emailPattern.test(email)) ? null : {email: true};
  };
}

export function passwordMatchValidator(passwordKey = 'password', confirmKey = 'confirmPassword'): ValidatorFn {
  return (group: AbstractControl): ValidationErrors | null => {
    const password = group.get(passwordKey)?.value;
    const confirm = group.get(confirmKey)?.value;
    return password && confirm && password !== confirm ? {passwordMismatch: true} : null;
  };
}

export function scrollToFirstError(container: Element | Document = document): void {
  setTimeout(() => {
    const firstError = container.querySelector<HTMLElement>('.ng-invalid.ng-touched');
    firstError?.scrollIntoView({behavior: 'smooth', block: 'center'});
  });
}